import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
export default async function getLead(id) {
	var leadInfo;
	await firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + id)
		.on('value', (snapshot) => {
			leadInfo = snapshot.val();
		});

	if (id && leadInfo) {
		console.log('sefwf', id);
		leadInfo['leadId'] = id;
	}
	return leadInfo;
}
